import { motion } from "motion/react";

/**
 * Lightweight, CSS/transform-only mock of the tracker dashboard.
 * Values are clearly labelled demo data — no real or implied user statistics.
 */
const BARS = [
  { label: "Physics", pct: 62 },
  { label: "Chemistry", pct: 48 },
  { label: "Maths", pct: 55 },
];

const TILES = [
  { label: "Revision due", value: "6" },
  { label: "Lectures today", value: "3" },
  { label: "Questions logged", value: "40" },
  { label: "Backlog items", value: "2" },
];

export function JeeTrackerVisual() {
  return (
    <div
      className="glass relative overflow-hidden rounded-[28px] border-hairline p-5"
      aria-label="Example view of the JEE preparation tracker dashboard with demo data"
      role="img"
    >
      <div
        aria-hidden
        className="neural-gradient pointer-events-none absolute -top-20 right-0 size-40 rounded-full opacity-20 blur-3xl"
      />
      <p className="relative text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        Example data
      </p>
      <p className="relative mt-1 text-sm font-bold tracking-tight">Syllabus completion</p>

      <div className="relative mt-4 space-y-3">
        {BARS.map((bar, i) => (
          <div key={bar.label}>
            <div className="flex items-center justify-between text-xs">
              <span className="font-semibold">{bar.label}</span>
              <span className="text-muted-foreground">{bar.pct}%</span>
            </div>
            <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-surface">
              <motion.div
                className="neural-gradient h-full rounded-full"
                initial={{ width: 0 }}
                whileInView={{ width: `${bar.pct}%` }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="relative mt-5 grid grid-cols-2 gap-2.5">
        {TILES.map((tile) => (
          <div key={tile.label} className="rounded-2xl border border-hairline bg-surface/60 p-3">
            <p className="text-lg font-extrabold tracking-tight">{tile.value}</p>
            <p className="mt-0.5 text-[11px] text-muted-foreground">{tile.label}</p>
          </div>
        ))}
      </div>

      <div className="relative mt-3 rounded-2xl border border-hairline bg-surface/60 p-3">
        <p className="text-[11px] text-muted-foreground">Next test plan</p>
        <p className="mt-0.5 text-sm font-semibold tracking-tight">
          Kinematics + Mole Concept · revision scheduled
        </p>
      </div>
    </div>
  );
}
